module.exports = __webpack_public_path__ + "static/HelveticaNeue-Thin-8625837a60ad14e4715c2908647e1342.otf";